<template>
  <v-dialog v-model="dialog" :fullscreen="$vuetify.breakpoint.smAndDown" persistent content-class="service-dialog" max-width="600px">
    <template v-slot:activator="{ on }">
      <SecondaryBtn icon="edit" small v-on="on">
        {{$t('Button.EditService')}}
      </SecondaryBtn>
    </template>
    <template v-if="dialog">
      <v-flex>
        <v-card flat dark>
          <v-toolbar dark color="primary">
            <v-toolbar-title>Edit Service</v-toolbar-title>
            {{ service.name }}
            <v-spacer></v-spacer>
            <v-btn icon @click.native="close()" dark>
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>
        </v-card>
      </v-flex>
      <v-flex style="overflow: auto;">
        <v-card flat>
          <v-card-text>
            <ServiceForm ref="serviceComponent" :service="service" v-on:validate="onValidate" v-on:submit="onSubmit" v-on:block="onBlock" />
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex>
        <v-card style="border-top: 1px solid #dddddd;">
          <v-card-actions>
            <ConfirmationDialog :disabled="isBlocked" @submit="remove" label="Remove" title="Remove service" text="Are you sure you want to remove this service?" />
            <v-spacer></v-spacer>
            <v-btn :disabled="!isValidated || isBlocked" color="success" @click="submit()">
              <v-icon left>done</v-icon>{{$t('Button.Save')}}
            </v-btn>
            <v-btn color="secondary" outline :disabled="isBlocked" @click="close()">{{$t('Button.Close')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </template>
  </v-dialog>
</template>

<script>
  import ServiceForm from '../ServiceForm'
  import ConfirmationDialog from '../../Helpers/ConfirmationDialog'

  import { createNamespacedHelpers } from 'vuex'
  const linkedServices = createNamespacedHelpers('linkedservices')

  export default {
    components: {
      ServiceForm,
      ConfirmationDialog,
    },
    props: {
      service: Object,
    },
    data: () => ({
      dialog: false,
      isValidated: false,
      isBlocked: false,
      isSaving: false,
    }),
    watch: {
      dialog(value) {
        if (value) {
          this.$nextTick(() => {
            this.$refs.serviceComponent.assignObject(this.service)
          })
        }
      },
    },
    methods: {
      ...linkedServices.mapActions(['getLinkedServices']),
      onValidate(result) {
        this.isValidated = result
      },
      onBlock(result) {
        this.isBlocked = result
      },
      onSubmit(service) {
        this.setStateSaving(true)

        this.$store.dispatch('services/updateService', service)
          .then(function() {
            this.getLinkedServices()
            this.setStateSaving(false)
            this.close()
          }.bind(this))
          .catch(function() {
            this.setStateSaving(false)
            this.$refs.serviceComponent.setMessageState(false, 'Failed to save', '')
          }.bind(this))
      },
      close() {
        this.reset()
        this.dialog = false
      },
      submit() {
        this.$refs.serviceComponent.submit()
      },
      remove() {
        this.$store.dispatch('services/deleteService', this.service)
          .then(function() {
            this.getLinkedServices()
            this.close()
          }.bind(this))
          .catch(function(error) {
            console.log(error)
            this.$refs.serviceComponent.setMessageState(false, 'Failed to delete',
              'Please check your internet connection')
          }.bind(this))
      },
      reset() {
        setTimeout(function() {
          this.isSaving = false
          this.isValidated = false
          if(this.$refs.serviceComponent) {
            this.$refs.serviceComponent.resetForm()
          }          
        }.bind(this), 500)
      },
      setStateSaving(value) {
        this.isSaving = value
        this.isBlocked = value
      },
    },
  }
</script>

<style scoped>
  .v-dialog--fullscreen>.v-card {
    min-height: 85px !important;
  }

  .v-dialog--fullscreen>.v-card+.v-card {
    min-height: Calc(100% - 85px) !important;
  }

  .v-dialog--fullscreen>.v-card+.v-card .v-card__text {
    padding: 0px !important;
  }
</style>
<style>
  .service-dialog {
    display: flex;
    flex-direction: column;
  }
</style>